<template>
  <div class="pm-dialog-previous">
    <div class="flex justify-center" style="padding:1rem;">
      <div class="input-area">
        <vs-input
          v-model="input"
          color="#2D9CDB"
          ref="input"
          @compositionstart="composing=true"
          @compositionend="composing=false"
        />
        <div class="close-icon" @click="clearInput">
          <feather-icon
            icon="XIcon"
            svgClasses="h-6 w-6"
          />
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      input: "",
      selectedIds: [],
      composing: false
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    enableSave() {
      return true;
    },
  },
  methods: {
    initData() {
      this.input = this.valueMap ? this.valueMap.port_name : '';
      this.$refs.input.focusInput()
    },
    clearInput() {
      this.input = ''
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave && !this.composing) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave && !this.composing) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#port_name'] = this.input;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-previous {
  .input-area {
    position: relative;
  }
  .close-icon {
    width: fit-content;
    position: absolute;
    top: 8px;
    right: 4px;
    cursor: pointer;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

